import http from '../http';

export const getSummary = (params={}) => http.get('/api/reports/summary', { params }).then(r=>r.data);
export const getTopProducts = (params={}) => http.get('/api/reports/top-products', { params }).then(r=>r.data);
export const getTimeline = (params={}) => http.get('/api/reports/timeline', { params }).then(r=>r.data);
export const getByCategory = (params={}) => http.get('/api/reports/by-category', { params }).then(r=>r.data);

// CSV ссылки удобно строить так:
export const csvUrl = (path, params={}) => {
  const usp = new URLSearchParams({ ...params, format: 'csv' }).toString();
  return `/api/reports/${path}?${usp}`;
};
